import { render } from "./ReleaseProcessing.vue?vue&type=template&id=f2ddf136&scoped=true&ts=true&lang=pug"
import script from "./ReleaseProcessing.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReleaseProcessing.vue?vue&type=script&setup=true&lang=ts"

import "./ReleaseProcessing.vue?vue&type=style&index=0&id=f2ddf136&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ddf136"]])

export default __exports__